<template>
  <header>
    <div class="cabecalho">
      <div class="ca-item box1">
        <img src="../img/impresso/iconMFS.svg" alt="TUTIPLAST" />
      </div>
      <div class="ca-item center">
        <h1>Relatório de RRIM</h1>
      </div>
      <div class="ca-item">
        <div class="codRRIM">
          Nº RRIM: <span>{{ codigo_rrim }}</span>
        </div>
      </div>
      <div class="ca-item box2">
        <img src="../img/impresso/logo-tuti.png" alt="" />
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    codigo_rrim: {
      type: String,
      required: true,
    },
  },
};
</script>

<style>
/* Cabeçalho */
.cabecalho {
  border-bottom: none;
  width: 100%;
  background: var(--white);
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #636363;
  border-top: 2px solid #636363;
}

.ca-item {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px;
}
.box1 {
  border-right: 2px solid #636363;
}
.box2 {
  border-left: 2px solid #636363;
  padding: 4px;
}
.ca-item img {
  width: 70%;
  height: 70%;
}

.codRRIM {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.codRRIM span {
  color: var(--black);
  font-weight: bold;
  font-size: 1.2rem;
}

.center {
  width: 180%;
}

/* Fim cabeçalho */
</style>
